import { useEffect, useRef, useState } from "react";

export function useFieldsetDisabled<T extends HTMLElement = HTMLElement>() {
  const ref = useRef<T>(null);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const fieldset = ref.current?.closest("fieldset");
    if (fieldset) setDisabled(fieldset.disabled);
  }, []);

  return { ref, disabled };
}
